import Service from "../AuthService";

const SharedMethod = {
    SharedMethod() {
        return Service.get(`shared-method`);
    }
};

export default SharedMethod;
